import { useEffect, useState } from 'react';
/** Re-render on an interval so overdue timers stay current. */
export function useNow(intervalMs = 1000, enabled = true) {
    const [nowMs, setNowMs] = useState(() => Date.now());
    useEffect(() => {
        if (!enabled)
            return;
        setNowMs(Date.now());
        const id = window.setInterval(() => setNowMs(Date.now()), intervalMs);
        return () => window.clearInterval(id);
    }, [intervalMs, enabled]);
    return nowMs;
}
